import {Record, List, Map} from 'immutable';

import {match, makeReducer} from 'web-app/util/redux';
import * as AbstractBudgetActions from 'web-app/react/abstract-bugdet/actions';
import {BUDGET_TYPE} from 'web-app/react/abstract-bugdet/constants';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import * as Actions from './actions';

const fetchFailed = (state: OccupancyState) =>
    state.merge({
        fetching: false,
        buckets: null,
        occupancyTotals: null,
        ageGroupsOccupancy: List(),
        groupOccupancy: List(),
    });

const fetchSuccess = (state: OccupancyState, {payload}: ReturnType<typeof Actions.fetchReportSuccess.action>) =>
    state.merge({
        csvLink: payload.reportData.csv ? payload.reportData.csv.url : null,
        fetching: false,
        buckets: List(payload.reportData.buckets),
        occupancyTotals: List(payload.reportData.occupancy.total),
        ageGroupsOccupancy: List(payload.reportData.occupancy.ageGroups),
        groupOccupancy: List(payload.reportData.occupancy.groups),
        behaviors: new BehaviorsCollection(payload.reportData.behaviors),
    });

export class OccupancyState extends Record<{
    csvLink: string | null;
    fetching: boolean;
    buckets: any;
    occupancyTotals: any;
    ageGroupsOccupancy: List<any>;
    groupOccupancy: List<any>;
    showOcc: boolean;
    budget: Map<string, number>; // Map<'year-month': string, number>
    behaviors: BehaviorsCollection;
}>({
    csvLink: null,
    fetching: true,
    buckets: null,
    occupancyTotals: null,
    ageGroupsOccupancy: List(),
    groupOccupancy: List(),
    showOcc: true,
    budget: Map<string, number>(),
    behaviors: new BehaviorsCollection([]),
}) {}

export default makeReducer<OccupancyState>(
    [
        match(Actions.reset, () => new OccupancyState()),
        match(Actions.fetchReport, state =>
            state.merge({
                fetching: true,
            }),
        ),
        match(Actions.fetchReportFailed, fetchFailed),
        match(Actions.fetchReportSuccess, fetchSuccess),
        match(Actions.toggleAgeGroupDetails, (state, {payload}) => {
            return state.merge({
                ageGroupsOccupancy: state.ageGroupsOccupancy.map(ageGroup => {
                    return {
                        ...ageGroup,
                        open: ageGroup.ageGroup.id === payload.ageGroupId ? payload.show : ageGroup.open,
                    };
                }),
            });
        }),
        match(Actions.toggleGroupDetails, (state, {payload}) => {
            return state.merge({
                groupOccupancy: state.groupOccupancy.map(group => {
                    return {
                        ...group,
                        open: group.group.groupId === payload.groupId ? payload.show : group.open,
                    };
                }),
            });
        }),
        match(Actions.toggleOccupancyPercentages, (state, {payload}) => {
            return state.merge({
                showOcc: payload.show,
            });
        }),
        match(AbstractBudgetActions.fetchBudgetSuccess, (state, {payload}) => {
            if (payload.type !== BUDGET_TYPE.OCCUPANCY) {
                return state;
            }
            return state.merge({
                budget: state.budget.merge(payload.response),
            });
        }),
        match(AbstractBudgetActions.updateBudgetSuccess, (state, {payload}) => {
            if (payload.type !== BUDGET_TYPE.OCCUPANCY) {
                return state;
            }
            return state.merge({
                budget: state.budget.merge(payload.response),
            });
        }),
    ],
    new OccupancyState(),
);
